export default __webpack_public_path__ + "static/media/img_next_lesson.662c0dd6.svg";